import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../shared';
import { CanalMidiaSocialSelectComponent } from './canal-midia-social-select.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        CanalMidiaSocialSelectComponent
    ],
    exports: [
        CanalMidiaSocialSelectComponent
    ]
})
export class CanalMidiaSocialSelectModule { }
